import React from 'react'
import { useQuery } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { IGHGStandards } from './options.type'

export const useGHGStandards = () => {
  const { data, isLoading, refetch } = useQuery<IGHGStandards[]>(['/options/ghgStandards'], {
    select: data => {
      return pathOr([], ['data'], data)
    },
  })

  const byId = React.useMemo(() => {
    return indexBy(prop('id'), data || [])
  }, [data])

  return { data, isLoading, refetch, byId }
}
